<template>
    <el-dialog
    :title="$t(title[target] || '')"
    width="660px"
    custom-class="export-excute-popper"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true"
    :visible="true"
    @close="$emit('close')"
    >
    <export-project-quick 
    v-if="target === 'quick'" 
    class="content" 
    :data="data" 
    @close="$emit('close')" 
    @change-target="$emit('change-target',$event)"
    ></export-project-quick>
    <export-project-rms 
    v-if="target === 'rms'" 
    class="content" :data="data" 
    @close="$emit('close')" 
    @change-target="$emit('change-target',$event)"
    ></export-project-rms>
    <export-project-white
    v-if="target === 'white'" 
    class="content" :data="data" 
    @close="$emit('close')" 
    @change-target="$emit('change-target',$event)"
    ></export-project-white>
    </el-dialog>
</template>
<script>
import exportProjectQuick from "./export-project-quick.vue";
import exportProjectRms from "./export-project-rms.vue";
import exportProjectWhite from "./export-project-white.vue";
export default {
    name: "export-excute-popper",
    components: {
        exportProjectQuick,
        exportProjectRms,
        exportProjectWhite
    },
    props: {
        data: Array,
        target: String
    },
    data(){
        return {
            title: {
                quick: "export_project.popper_title_quick",
                rms: "export_project.popper_title_rms",
                white: "export_project.popper_title_rms"
            },
        }
    }
}
</script>
<style lang="scss">
.export-excute-popper{
    .content{
        width: 100%;
        overflow: hidden;
    }
}
</style>